import { createI18n } from 'vue-i18n'
import { messages, defaultLocale } from '@/locales'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import 'dayjs/locale/vi'
import 'dayjs/locale/en'

// Lấy locale từ localStorage hoặc dùng default
const savedLocale = localStorage.getItem('user-locale') || defaultLocale

export const i18n = createI18n({
  legacy: false, // Sử dụng Composition API
  locale: savedLocale,
  fallbackLocale: defaultLocale,
  messages,
  globalInjection: true, // Cho phép sử dụng $t trong template
})

// Set initial dayjs locale
dayjs.locale(savedLocale)

// Helper function để đổi ngôn ngữ
export function setLocale(locale: string) {
  i18n.global.locale.value = locale as 'vi' | 'en' | 'ja'
  localStorage.setItem('user-locale', locale)
  document.querySelector('html')?.setAttribute('lang', locale)
  // Sync dayjs locale
  dayjs.locale(locale)
}

// Helper function để lấy locale hiện tại
export function getCurrentLocale() {
  return i18n.global.locale.value
}

export default i18n
